export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_SORT = 'name';

/**
 * Checks if the sort value is sorted by the given header value.
 * @param headerValue - The header value to check.
 * @param sortValue - The string to compare against the header value.
 * @returns True if the sort value is sorted by the given header value, false otherwise.
 */
export const isSortedBy = (headerValue: string, sortValue?: string): boolean => sortValue === headerValue || sortValue === `-${headerValue}`;

/**
 * Checks if the sort value is sorted in descending order.
 * @param sortValue - The string to check.
 * @returns True if the sort value is sorted in descending order, false otherwise.
 */
export const isSortDesc = (sortValue?: string): boolean => sortValue?.startsWith('-');
